import store from 'app/store'

import VGPopUp from 'components/Controls/VGPopUp'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import ReactDom, { createPortal, unmountComponentAtNode } from 'react-dom'
import { utils, LoginUserType, ResponseCode } from "../../utils/Utils";
import $ from "jquery";
import Form from "react-bootstrap/Form";

const EditDNS = (props) => {

    const [response, setResponse] = useState(props.response);

    var domainName = props.domainName;

    const DNSCount = useRef(props.response.length);

    const PopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog"));
    };

    const PopupDNSClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog1"));
    };

    const ResetRecords = (domainName) => {
        props.resetDefaultDNS(domainName)
        PopupDNSClose();
    }
    unmountComponentAtNode(document.getElementById("OpenDialog1"));


    const ResetDefaultDNSPopup = (domainName) => {
        if (!props.isModifyAllowed) {
            utils.ShowAlert("Alert", "You do not have permission to disconnect domain.", "OpenDialog");
        }
        else {
            return ReactDom.render(
                <VGPopUp
                    id={"ResetDefaultDNSPopup"}
                    show={true}
                    onHide={PopupDNSClose}
                    title={"Reset Records"}
                    dialogClassName="cancelauto-renew-alert"
                    body={
                        <div className="alertContent">
                            <p>Are you sure you want to reset <b>{domainName.toLowerCase()}</b> DNS settings?</p>
                        </div>
                    }
                    footer={
                        <Fragment>
                            <button className="w-button w-button-secondary" onClick={() => PopupDNSClose()}>Close</button>
                            <button className="w-button w-button-destructive-outline" onClick={() => ResetRecords(domainName)}>Reset Records</button>
                        </Fragment >
                    }
                    isRemoveTabModalIndex={false}
                    isShowFooter={true}
                    size={"md"}
                    backdrop={true}
                />,
                document.getElementById("OpenDialog1"));
        }
    }

    const removeDNSRow = async (index, ID) => {
        var responseFilter = response.filter(
            (col) => col.rank === index
        );
        if (responseFilter.length > 0) {
            responseFilter[0].isActive = false;
            responseFilter[0].isChanges = true;
            response.map((d, i) => {
                if (d.rank === index) {
                    response[i] = responseFilter[0];
                }
            })
            setResponse(response);
        }
        $('table#tableDNS tr#dns-' + index).remove();
    }

    const copyToClipboard = (d) => {
        var contorys = $(".copied-text-blue");
        if (contorys.length > 0) {
            $.grep(contorys, (ele) => {
                ele.classList.remove("copied-text-blue");
            })
        }
        if (d !== "") {
            navigator.clipboard.writeText(d)
        }
    }
    const AddDNS = () => {
        DNSCount.current = DNSCount.current + 1;
        const item = {
            id: "",
            isAdded: false,
            rank: DNSCount.current,
            merchantID: props.reactBusinessId,
            domainName: domainName,
            recordType: "-1",
            recordName: "",
            recordValue: "",
            status: false,
            isActive: true,
            isChanges: true,
            isDefault: false,
            createdBy: props.reactUserID,
            message: ""
        };
        setResponse(prevresponse => ([...prevresponse, item]));
    }

    const SaveDNSProcess = () => {
        let saveDNS = response.filter(
            (d) => (d.id == "" && d.isActive == true) || (d.id != "" && d.isChanges == true && d.isActive == false)
        );
        if (saveDNS.length > 0) {
            props.saveDNSProcess(saveDNS, domainName);
        }
        else {
            PopupClose();
        }
    }

    const SaveDNSValidate = () => {
        var isSave = true;
        response.map((d, i) => {
            if (d.id == "" && d.isActive == true) {
                if (d.recordType == "-1") {
                    $("#frmgroup-recordType-" + (i + 1)).addClass("form-row-invalid")
                    isSave = false;
                }
                else {
                    $("#frmgroup-recordType-" + (i + 1)).removeClass("form-row-invalid")
                }

                if (!utils.Validate(d.recordName)) {
                    $("#frmgroup-host-" + (i + 1)).addClass("form-row-invalid")
                    isSave = false;
                }
                else {
                    $("#frmgroup-host-" + (i + 1)).removeClass("form-row-invalid")
                }

                if (!utils.Validate(d.recordValue)) {
                    $("#frmgroup-record-" + (i + 1)).addClass("form-row-invalid")
                    isSave = false;
                }
                else {
                    $("#frmgroup-record-" + (i + 1)).removeClass("form-row-invalid")
                }
            }
            if (i == response.length - 1) {
                if (isSave) {
                    SaveDNSProcess();
                }
            }
        });
    }


    const ChangeRecordType = (event, index) => {
        var responseFilter = response.filter(
            (col) => col.rank === index
        );
        if (responseFilter.length > 0) {
            responseFilter[0].recordType = event.target.value;
            if (event.target.value != "-1") {
                $("#frmgroup-recordType-" + index).removeClass("form-row-invalid")
            }
            else {
                $("#frmgroup-recordType-" + index).addClass("form-row-invalid")
            }
            response.map((d, i) => {
                if (d.rank === index) {
                    response[i] = responseFilter[0];
                }
            })
            setResponse(response);
        }
    }

    const ChangeHost = (event, index) => {
        var responseFilter = response.filter(
            (col) => col.rank === index
        );
        if (responseFilter.length > 0) {
            responseFilter[0].recordName = event.target.value;
            if (utils.Validate(event.target.value)) {
                $("#frmgroup-host-" + index).removeClass("form-row-invalid")
            }
            else {
                $("#frmgroup-host-" + index).addClass("form-row-invalid")
            }
            response.map((d, i) => {
                if (d.rank === index) {
                    response[i] = responseFilter[0];
                }
            })
            setResponse(response);
        }
    }

    const ChangeValue = (event, index) => {
        var responseFilter = response.filter(
            (col) => col.rank === index
        );
        if (responseFilter.length > 0) {
            responseFilter[0].recordValue = event.target.value;
            if (utils.Validate(event.target.value)) {
                $("#frmgroup-record-" + index).removeClass("form-row-invalid")
            }
            else {
                $("#frmgroup-record-" + index).addClass("form-row-invalid")
            }
            response.map((d, i) => {
                if (d.rank === index) {
                    response[i] = responseFilter[0];
                }
            })
            setResponse(response);
        }
    }

    return createPortal(
        <VGPopUp
            id={"EditDNSReacord"}
            show={true}
            onHide={PopupClose}
            title={"Edit DNS Records"}
            size={"xl"}
            dialogClassName="vg-w1400"
            body={
                <Fragment>
                    <p>This is your domain provider settings for your domain <span className='fw-600'>{props.domainName}</span>.</p>
                    <div className="vg-table-wrapper py-t8 py-b24 tablscrollbdr">
                        <div className="vg-table-bdr">
                            <table className="table" id="tableDNS">
                                <thead>
                                    <tr>
                                        <th>Domain</th>
                                        <th>Record Type</th>
                                        <th>Host</th>
                                        <th>Required Value</th>
                                        <th>Connection</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {response.length > 0 && response.map((d, index) => {
                                        return (
                                            <Fragment>
                                                <tr id={"dns-" + (index + 1)}>
                                                    {d.isAdded ? <td data-lbl="Domain">{d.domainName}</td> : <td data-lbl="Domain" style={{ verticalAlign: "middle" }}>{d.domainName}</td>}
                                                    {d.isAdded ? <td data-lbl="Type">{d.recordType}</td> : <td data-lbl="Type"> <div className="vg-wb-select" style={{ verticalAlign: "middle" }}>
                                                        <Form.Group id={"frmgroup-recordType-" + (index + 1)} className="form-row select-drop-arrow">
                                                            <select id={"recordType-" + (index + 1)} onChange={(e) => ChangeRecordType(e, index + 1)} className="domain_provider_dropdown dropdownfoucs vg-wb-select form-control" style={{ width: "195px" }}>
                                                                <option value="-1">Select Record Type</option>
                                                                {/*  <option value="A">A</option> */}
                                                                {/* <option value="AAAA">AAAA</option> */}                                                                
                                                                <option value="MX">MX</option>
                                                                <option value="NS">NS</option>
                                                                <option value="SOA">SOA</option>
                                                                <option value="SRV">SRV</option>
                                                                <option value="TXT">TXT</option>
                                                                <option value="CNAME">CNAME</option>
                                                            </select>
                                                        </Form.Group>
                                                    </div></td>}
                                                    {d.isAdded ? <td data-lbl="Host">{d.recordName}</td> : <td data-lbl="Host" style={{ verticalAlign: "middle" }}><Form.Group id={"frmgroup-host-" + (index + 1)} className="form-row"><input onChange={(e) => ChangeHost(e, index + 1)} className="form-control" type="text" placeholder="Host" /></Form.Group></td>}
                                                    {d.isAdded ? <td className="word-break-td" data-lbl="Required Value"><Fragment>{d.recordValue} {d.recordValue !== "" && <div className="copytoclipboard icons" onClick={(e) => { copyToClipboard(d.recordValue); e.target.classList.add("copied-text-blue") }}><div ><i class="fal fa-copy"></i></div></div>}</Fragment></td> : <td data-lbl="Host" style={{ verticalAlign: "middle" }}> <Form.Group id={"frmgroup-record-" + (index + 1)} className="form-row"><input onChange={(e) => ChangeValue(e, index + 1)} className="form-control" type="text" placeholder="Value" /></Form.Group></td>}
                                                    {d.isAdded ?
                                                        d.status ?
                                                            <td colSpan={d.isDefault ? 2 : 1} data-lbl="Connection">{d.status == true && <span className="text-connected">Connected</span>}
                                                                {d.status == false && <span className="text-disconnected">Disconnected</span>}</td>
                                                            :
                                                            <td colSpan={d.isDefault ? 2 : 1}><span className="text-disconnected">Disconnected</span></td>
                                                        : <td colSpan={d.isDefault ? 2 : 1} style={{ verticalAlign: "middle" }}><span className="text-disconnected">Disconnected</span></td>
                                                    }
                                                    {d.isDefault == false && <Fragment>{d.isAdded ? <td style={{ color: "blue", cursor: "pointer" }}>
                                                        <button onClick={() => removeDNSRow(index + 1, d.id)} class="invisible-button" data-tooltip="delete"><svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 14 16" fill="none"><path d="M12.8594 3.21875C13.2402 3.21875 13.5625 3.54102 13.5625 3.92188C13.5625 4.33203 13.2402 4.625 12.8594 4.625H12.5078L11.8047 14.1465C11.7168 15.1426 10.9258 15.875 9.92969 15.875H4.04102C3.04492 15.875 2.25391 15.1426 2.16602 14.1465L1.46289 4.625H1.14062C0.730469 4.625 0.4375 4.33203 0.4375 3.92188C0.4375 3.54102 0.730469 3.21875 1.14062 3.21875H3.16211L4.24609 1.60742C4.53906 1.16797 5.06641 0.875 5.62305 0.875H8.34766C8.9043 0.875 9.43164 1.16797 9.72461 1.60742L10.8086 3.21875H12.8594ZM5.62305 2.28125C5.53516 2.28125 5.44727 2.33984 5.41797 2.39844L4.86133 3.21875H9.10938L8.55273 2.39844C8.52344 2.33984 8.43555 2.28125 8.34766 2.28125H5.62305ZM11.1016 4.625H2.86914L3.57227 14.0586C3.60156 14.293 3.80664 14.4688 4.04102 14.4688H9.92969C10.1641 14.4688 10.3691 14.293 10.3984 14.0586L11.1016 4.625Z" fill="#B42318"></path></svg></button>
                                                    </td> : <td style={{ color: "blue", cursor: "pointer", verticalAlign: "middle" }}><button onClick={() => removeDNSRow(index + 1, d.id)} class="invisible-button" data-tooltip="delete"><svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 14 16" fill="none"><path d="M12.8594 3.21875C13.2402 3.21875 13.5625 3.54102 13.5625 3.92188C13.5625 4.33203 13.2402 4.625 12.8594 4.625H12.5078L11.8047 14.1465C11.7168 15.1426 10.9258 15.875 9.92969 15.875H4.04102C3.04492 15.875 2.25391 15.1426 2.16602 14.1465L1.46289 4.625H1.14062C0.730469 4.625 0.4375 4.33203 0.4375 3.92188C0.4375 3.54102 0.730469 3.21875 1.14062 3.21875H3.16211L4.24609 1.60742C4.53906 1.16797 5.06641 0.875 5.62305 0.875H8.34766C8.9043 0.875 9.43164 1.16797 9.72461 1.60742L10.8086 3.21875H12.8594ZM5.62305 2.28125C5.53516 2.28125 5.44727 2.33984 5.41797 2.39844L4.86133 3.21875H9.10938L8.55273 2.39844C8.52344 2.33984 8.43555 2.28125 8.34766 2.28125H5.62305ZM11.1016 4.625H2.86914L3.57227 14.0586C3.60156 14.293 3.80664 14.4688 4.04102 14.4688H9.92969C10.1641 14.4688 10.3691 14.293 10.3984 14.0586L11.1016 4.625Z" fill="#B42318"></path></svg></button></td>}
                                                    </Fragment>
                                                    }
                                                </tr>
                                            </Fragment>
                                        )
                                    })}
                                    <Fragment>
                                        <tr colspan="6">
                                            <td style={{ color: "blue", cursor: "pointer", width: "130px", marginTop:"0px", padding:"8px 8px" }} className='reset-default-records-btn'><a onClick={() => AddDNS()}>+ Add Records</a></td>
                                        </tr>
                                    </Fragment>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <p className='reset-default-records-btn'><a onClick={() => ResetDefaultDNSPopup(props.domainName)}>Reset Default Records</a></p>
                </Fragment>
            }
            footer={
                <Fragment>
                    <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                    <button className="w-button w-button-primary" onClick={() => SaveDNSValidate()}>Save</button>
                </Fragment >
            }
            isRemoveTabModalIndex={false}
            isShowFooter={true}
            backdrop={true}
        />,
        document.getElementById("OpenDialog"))

};
export default EditDNS